import React from "react";
import Reports from "./Reports";

const OverviewReport = () => <Reports reportType="overview" />;

export default OverviewReport;
